import { React } from '../../Imports';
import { useEffect, useCallback } from 'react';

// Custom hook for programmatic title setting
const usePageTitle = (title?: string) => {
    const setTitle = useCallback((newTitle: string) => {
        if (document.title !== newTitle) {
            document.title = newTitle;
        }
    }, []);

    useEffect(() => {
        if (title) {
            setTitle(title);
        }
    }, [title, setTitle]);

    return setTitle;
};

// Functional component that sets the title and returns children
const PageTitleSetter: React.FC<{ title: string; children: React.ReactNode }> = ({ title, children }) => {
    usePageTitle(title);
    return <>{children}</>;
};

export { usePageTitle, PageTitleSetter };
